
import DatePicker from "@shared/components/datePicker/datePicker.vue";
import Vue from "vue";
import Component from "vue-class-component";
import { DateHelper } from "@shared/core/helpers/dateHelper";
import { Prop } from "@modules/vue-property-decorator";

@Component({
  components: {
    DatePicker,
  },
})
export default class ResponsiveDateSelector extends Vue {
  @Prop({required: false, default: 0}) minAnticipationMins!: any | null;
  @Prop({required: false, default: 0}) maxAnticipationMins!: any | null;
  windowWidth: number = window.innerWidth;
  availableDates: any[] = [];
  selectedDate: any = null;

  async mounted() {
    this.loadMoreDates(true);
  }

  handleScroll() {
    const container = this.$refs.dateSelector as HTMLElement;
    if (
      container.scrollLeft + container.clientWidth >=
      container.scrollWidth - 10
    ) {
      this.loadMoreDates();
    }
  }

  loadMoreDates(initialLoad = false) {
    const today = new Date();
    const startDate = new Date(today);
    startDate.setMinutes(today.getMinutes() + this.minAnticipationMins);

    const maxDate = new Date(today);
    maxDate.setMinutes(today.getMinutes() + (this.maxAnticipationMins || 366 * 1440));

    let lastDate =
      this.availableDates.length > 0
        ? new Date(this.availableDates[this.availableDates.length - 1].fullDate)
        : new Date(startDate);

    const locale = Vue.prototype.$culture;

    while (lastDate < maxDate) {
      const newDate = new Date(lastDate);
      const newFullDate = DateHelper.toServerFormat(newDate);

      if (!this.availableDates.some((date) => date.fullDate === newFullDate)) {
        this.availableDates.push({
          weekday: this.capitalizeFirst(
            newDate.toLocaleString(locale, { weekday: "short" })
          ),
          day: newDate
            .getDate()
            .toString()
            .padStart(2, "0"),
          month: this.capitalizeFirst(
            newDate.toLocaleString(locale, { month: "short" })
          ),
          fullDate: newFullDate,
          date: DateHelper.formatDate(newDate, "yyyy-MM-dd")
        });
      }

      lastDate.setDate(lastDate.getDate() + 1);
    }

    if (initialLoad) {
      this.$nextTick(() => {
        const container = this.$refs.dateSelector as HTMLElement;
        if (container) {
          container.scrollLeft = 0;
        }

        if (this.availableDates.length > 0 && !this.selectedDate) {
          this.selectDate(this.availableDates[0]);
        }
      });
    }
  }

  capitalizeFirst(str: string) {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }

  async selectDate(date) {
    this.selectedDate = date;
    this.$emit("dateSelected", date.date);
  }

}
